export default ({ name, path, meta } = {}) => ({
  name: name + '.guide',
  path: path + '/guide',
  meta,
  component: () => import('./PhotoGuideRoute.vue'),
  children: [
    {
      name: name + '.guide.feed',
      path: ':guide',
      meta,
      component: () => import('./Feed/PhotoGuideFeedRoute.vue')
    },
    {
      name: name + '.guide.settings',
      path: ':guide/settings',
      meta,
      component: () => import('./Settings/PhotoGuideSettingsRoute.vue')
    }
  ]
})
